module.exports = __webpack_public_path__ + "img/app-nestjs-angular-graphql.78243d63.jpg";